import { render, staticRenderFns } from "./VoiceMails.vue?vue&type=template&id=29bf158d&"
import script from "./VoiceMails.vue?vue&type=script&lang=js&"
export * from "./VoiceMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports